import React from "react";
import { useTranslation } from "react-i18next";
import { AllocationUnit } from "@common/allocationUnit";
import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function SelectedProfile({ costProfile }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.selectedProfile}>
      <Icon className={styles.icon} />
      <p className={styles.name}>{costProfile.name}</p>
      {typeof costProfile.cost !== "undefined" && (
        <p className={styles.cost}>
          {costProfile.cost} €/
          <AllocationUnit format="text" />
        </p>
      )}
    </div>
  );
}

export { SelectedProfile };
